<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="ContractualDocsContainer">
  <!-- <div class="banner">
    </div> -->
  <nav *ngIf="!data.isModal" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <a (click)="goHome()">Home</a>
      </li>
      <li class="breadcrumb-item active" aria-current="page">
        Contractual Documents
      </li>
    </ol>
  </nav>
  <div class="docsFilterContainer">
      <label>Competency</label>
    <div
      motifDropdown
      ngClass="docsFilter"
      placement="bottom-right"
      scrollStrategy="reposition"
      [autoClose]="true"
      [closeOnBackdropClick]="true"
      [open]="false"
    >
      <button
        
        aria-label="Dropdown toggle example"
        motifDropdownToggle
        id="selectCompetencyDropdown"
      >
        {{ selectedCompetency }}
        <motif-icon [src]="'/assets/icons/navigation/ic_expand_more_24px.svg'"></motif-icon>
      </button>
      <div motifDropdownMenu aria-labelledby="selectCompetencyDropdown" >
        <button (click)="updateDocuments('Select','competency')" motifDropdownItem>
            Select
          </button>
          <button (click)="updateDocuments(item.value, 'competency')" motifDropdownItem *ngFor="let item of COMPETENCIES | keyvalue; track item">
              {{ item.value }}
            </button>
      </div>
    </div>
    <label>Type</label>
    <div
      motifDropdown
      ngClass="docsFilter"
      placement="bottom-right"
      scrollStrategy="reposition"
      [autoClose]="true"
      [closeOnBackdropClick]="true"
      [open]="false"
    >
      <button
        aria-label="Dropdown toggle example"
        motifDropdownToggle
        id="selectTypeDropdown"
      >
        {{ selectedType }}
        <motif-icon [src]="'/assets/icons/navigation/ic_expand_more_24px.svg'"></motif-icon>
      </button>
      <div motifDropdownMenu aria-labelledby="selectTypeDropdown" >
        <button (click)="updateDocuments('Select','type')" motifDropdownItem>
            Select
          </button>
          <button (click)="updateDocuments(item.value, 'type')" motifDropdownItem *ngFor="let item of DOC_TYPES | keyvalue; track item">
              {{ item.value }}
            </button>
      </div>
    </div>
    <button (click)="updateDocuments('','')" class="clearButton" >
        Clear All
      </button>
  </div>
  <div class="documentListContainer" *ngIf="documents.length" id="documentList">
    <motif-table
      class="docsTable"
      [rowData]="documents"
      [columnDefs]="colDefs"
    ></motif-table>
  </div>
  <div class="noDataContaner" *ngIf="!documents.length" >
    <span>No Documents</span>
  </div>
  <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
